import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCt1B4hlrgSxUp77ay0SWxleFKOnEX8Y68",
  authDomain: "ageizolasyon-b4cef.firebaseapp.com",
  projectId: "ageizolasyon-b4cef",
  storageBucket: "ageizolasyon-b4cef.firebasestorage.app",
  messagingSenderId: "957052971128",
  appId: "1:957052971128:web:e867424a481ba72513a58d",
  measurementId: "G-KLCHXXTG4R"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db   = getFirestore(app);
export default app;
